export const setUserToken = "SET_USER_TOKEN";
export const setUserInfo = "SET_USER_INFO";
export const setUserOrgs = "SET_USER_ORGS";
export const selectCurrentOrg = "SELECT_CURRENT_ORG";
export const selectCurrentOrgByName = "SELECT_CURRENT_ORG_BY_NAME";
export const clearUser = "CLEAR_USER";
export const setIsAdmin = "SET_IS_ADMIN";
export const setIsSuperAdmin = "SET_IS_SUPER_ADMIN";
export const setEmployeeByPin = "SET_EMPLOYEE_BY_PIN";
export const setUserScreenLocked = "SET_USER_SCREEN_LOCKED";